{
  "addAddress": "Add address",
  "addContactData": "Add contact data",
  "additionalId": "Article number",
  "additionalStockInfos": "Additional stock information",
  "additionalTax": "plus{0} VAT",
  "addProducts": "Add products",
  "addProductToCollection": "Add product to a collection",
  "addProductToComparison": "Add product to product comparison",
  "addProductToQuote": "Add product to a quote request",
  "address": {
    "addition": "Extra address line",
    "city": "City",
    "clientNumber": "Client number",
    "companyName": "Name and legal form",
    "country": "Country",
    "defaultBillingAddress": "Default billing address",
    "defaultDeliveryAddress": "Default shipping address",
    "details": "Details",
    "email": "Email",
    "phone": "Telephone",
    "postBox": "Post office box",
    "primaryAddress": "Primary address",
    "street": "Street",
    "url": "URL",
    "website": "Website",
    "zipCode": "Postcode",
    "zipCodeLong": "Postal code"
  },
  "addresses": "Addresses",
  "addToCart": "Add to cart",
  "archiveAll": "Archive all",
  "availability": "Availability",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Back to ITscope",
  "billingAddress": "Billing address",
  "cancel": "Cancel",
  "cart": {
    "optimizationFailed": "The shopping cart optimisation failed",
    "optimizationUnavailable": "Unable to execute shopping cart optimisation since there are more than 250 items in the shopping cart",
    "removeAll": "Empty shopping cart",
    "removeAllError": "Shopping cart could not be emptied",
    "removeAllSuccess": "Shopping cart was successfully emptied"
  },
  "cartOutdated": {
    "description": "The order could not be sent because the shopping cart is no longer up to date. Please reload the cart and place the order again.",
    "title": "Shopping cart no longer up to date"
  },
  "cartPositionComment": "Item remarks",
  "categories": "Categories",
  "changed": "Changed",
  "changePassword": "Change password",
  "charger": {
    "charger": "Charger",
    "chargerIncludedTooltip": "Charger is included with this product.",
    "chargerNotIncludedHint": "Chargers with the following charging compatibilities can be used with this product.",
    "chargerNotIncludedTooltip": "Charger is not included with this product.",
    "noCharger": "No Charger"
  },
  "checkEmail": "Check e-mail",
  "checkoutExpiredDialog": {
    "buttonCaption": "Back to the checkout",
    "description": "Your order is waiting",
    "title": "Are you still there?"
  },
  "chooseAddress": "Choose address",
  "clientNumber": "Client number",
  "closeErrorOrders": "Close column with faulty orders",
  "closeFilter": "Close the filter",
  "closeMessage": "Close message",
  "closeQuoteActivity": "Close activities",
  "collapseAccessoryCategory": "Collapse accessory category ‘{0}’",
  "collapseDescription": "Collapse description ‘{0}’",
  "collection": {
    "addAttachment": "Add attachment",
    "addCollection": "New collection",
    "addedToCartFailure": "Collection could not be added to cart",
    "addedToCartPartialSuccess": "Some items could not be added to the cart",
    "addedToCartSuccess": "Collection added to cart",
    "addProductToExistingCollection": "Add product to existing collection:",
    "addProductToNewCollection": "or create new collection:",
    "addToCart": "Add to cart",
    "assignee": "Responsible employee",
    "collections": "Collections",
    "collectProduct": "Collect product",
    "data": "Dates",
    "deleteAction": "Delete collection",
    "deleteDialog": "Are you sure you want to remove this collection?",
    "deletedMessage": "Collection was removed",
    "duplicate": "Duplicate",
    "editTitle": "Change title of the collection",
    "emailSent": "The collection was successfully sent by e-mail.",
    "emptyCollection": "No products in this collection",
    "lastModified": "Last modified",
    "noCollectionAvailable": "No collection available",
    "productAlreadyInCollection": "Product already in the collection",
    "sendEmail": "Share by e-mail",
    "shareCollection": "Share collection \"{0}\" by e-mail",
    "subject": "Subject",
    "success": {
      "itemRemoved": "Product successfully removed"
    }
  },
  "common": {
    "archive": "Archive",
    "archived": "Archived",
    "comment": "Comment",
    "commentPlaceholder": "Add comment here...",
    "comments": "Comments",
    "dearchive": "Dearchive",
    "error": {
      "changeQuantity": "The quantity could not be changed",
      "removeItem": "Item could not be deleted",
      "updateAssignee": "The responsible employee could not be changed",
      "updateComment": "The comment could not be updated",
      "updateName": "The collection title could not be updated"
    },
    "sellerComment": "Seller comment"
  },
  "company": {
    "deleteEmployee": "Remove employee",
    "employee": "Employee",
    "employeeDeleted": "Employee was removed",
    "employees": "Employees"
  },
  "companyData": "Company data",
  "companyRegistration": "A company does not yet exist for the e-mail address provided. Please fill out the form below to request access.",
  "condition": {
    "B_STOCK": "B-stock",
    "BUILD_TO_ORDER": "Build to order",
    "BULK": "Bulk",
    "DEMONSTRATION_MODEL": "Demonstration model",
    "FACTORY_REFURBISHED": "Factory refurbished",
    "NEW": "New",
    "NEWPULL": "Spare part from new device",
    "NOT_FOR_RESALE": "Not for resale",
    "REFURBISHED": "Refurbished",
    "RMA_WARE": "RMA",
    "USED": "Used",
    "USEDPULL": "Spare part from used device"
  },
  "conditionTooltip": {
    "conditionLabel": "Condition",
    "monthsWarranty": "months warranty"
  },
  "contactData": {
    "contactData": "contact details",
    "email": "E-Mail",
    "firstName": "First Name",
    "lastName": "Last Name"
  },
  "contactTitles": {
    "diverse": "Mx.",
    "female": "Ms.",
    "male": "Mr.",
    "unspecified": "unspecified"
  },
  "continue": "Continue",
  "copy": "Copy",
  "coreData": "Core Data",
  "costs": "Costs",
  "create": "Create",
  "created": "Created",
  "createdDate": "Creation date",
  "cto": {
    "appleCtoFinder": "Apple CTO finder",
    "configure": "Configure {0}",
    "customiseConfiguration": "Customise configuration",
    "foundProduct": "Found product",
    "noProductFound": "No product could be found for this configuration",
    "selectBaseModel": "Select base model",
    "selectedConfiguration": "Selected configuration",
    "selectProductClass": "Select Apple product class"
  },
  "customerOrderId": "Customer order number",
  "datasheet": "Datasheet",
  "datasheetError": "Could not load datasheet",
  "datasheetManufacturer": "Manufacturer’s datasheet",
  "datasheetNotFound": "No data sheet available for this product",
  "datasheetPdf": "Datasheet (PDF)",
  "decline": "Decline",
  "declineReason": "Decline reason",
  "delete": "Delete",
  "deleteAddress": "Delete address",
  "deleteAddressDialog": "Are you sure you want to delete this address?",
  "deleteContactData": "Delete contact data",
  "deliveryTracking": {
    "deliveryTracking": "Shipping information",
    "trackPackage": "Track package"
  },
  "departments": {
    "Accounting": "Accounting",
    "Extern": "Extern",
    "IT": "IT",
    "Management": "Management",
    "Marketing": "Marketing",
    "Other": "Other",
    "Purchasing": "Purchasing",
    "RegistrationPending": "Registration pending",
    "Sales": "Sales",
    "ServiceSupport": "Service/Support"
  },
  "discount": "- {0} discount",
  "documentError": "Unable to load document",
  "downloadAllOrderDocumentsAsPdf": "Download all order documents as PDF",
  "downloadOrderDocumentAsPdf": "Download order document ‘{0}’ as PDF",
  "ean": "EAN",
  "editAddress": "Edit address",
  "editCollectionAssignee": "Change responsible employee",
  "editContactData": "Edit contact data",
  "ellipsis": "...",
  "emailAddress": "Email address",
  "emailForRegistration": "Please enter an e-mail address with which you would like to register.",
  "emailRequestPriceHint": "The following mail will be sent to the shop owner (this is just a preview of the text):",
  "emptyCart": "There's no product in the shopping cart",
  "epeat": "EPEAT certified",
  "epeatTooltip": {
    "description1": "International Ecolabel for IT products.",
    "description2": "Assesses energy efficiency, recyclability and choice of materials, among other things.",
    "description3": "Levels: Bronze, Silver, Gold - the higher, the more environmentally friendly.",
    "title": "EPEAT label"
  },
  "eprel": {
    "energyEfficiency": "Energy Label",
    "energyEfficiencyAndProductDatasheet": "Energy Label Information",
    "energyEfficiencyInformationSheet": "Datasheet"
  },
  "error": {
    "addressCreated": "Address could not be created",
    "addressDeleted": "Address could not be deleted",
    "addressesNotFound": "Unable to load addresses",
    "addressPropertyInvalid": "Address field {propertyName} is invalid.",
    "addressSaved": "Address could not be saved",
    "alreadyInvited": "Colleague {0} is already invited",
    "alreadyRegistered": "Colleague {0} is already registered",
    "cartNotFound": "Cart could not be loaded",
    "categoriesNotFound": "Unable to load categories",
    "changePassword": "Something went wrong while trying to change the password",
    "changeQuantity": "The quantity in the cart could not be changed",
    "collectionNotFound": "Collection could not be loaded",
    "documentsNotFound": "Unable to load documents",
    "emailAlreadyRegistered": "Email is already registered.",
    "emptyField": "Please enter a valid value for {0}.",
    "essentialShopActivationRequested": "Something went wrong while trying to send the request",
    "fileTooLarge": "The file size is too large",
    "genericError": "Something went wrong",
    "identifiersNotFound": "Identifiers could not be loaded",
    "invalidCharacters": "Only letters, numbers, and the characters _ / . # +, as well as parentheses and square brackets, are allowed (minimum of 3 characters)",
    "invalidEmail": "Invalid email address",
    "invalidEmails": "The following email addresses are invalid: {0}",
    "invalidName": "Invalid name",
    "invalidNegativeNumber": "Only positive numbers allowed",
    "invalidNumber": "Invalid number",
    "invalidUrl": "Invalid URL",
    "invalidWhitespace": "No leading, trailing, or multiple consecutive spaces allowed",
    "invitation": "Something went wrong while trying to send the invitation",
    "keywordTooShort": "Please enter a search term with at least 2 characters",
    "mailBlacklisted": "The Domain {0} has not been whitelisted. Contact your portal administrator..",
    "noAdmin": "You need admin rights to invite colleagues",
    "noConsent": "The consent has to be signed",
    "oldPassword": "Current password is invalid",
    "ordersNotFound": "Unable to load orders",
    "pageNotFound": "Page not found",
    "passwordNotAllowedChar": "The password contains one or more forbidden characters.",
    "passwordRepeat": "The passwords do not match.",
    "passwordRequirements": "Your password does not meet the current password requirements.",
    "positiveDigit": "The value has to be positive",
    "productAdded": "Product could not be added to cart",
    "productAlreadyInComparison": "Product is already in comparison",
    "productComparisonMaxNumber": "The comparison is limited to 3 products",
    "productDeleted": "Product could not be removed from cart",
    "productNotAvailableBySupplier": "This supplier does not offer the product.",
    "productNotFound": "Product could not be loaded",
    "productRequest": "Something went wrong while trying to send the request",
    "productTypeIncorrectForComparison": "Only products of the same category can be compared",
    "quoteForbidden": "This quote is not yet active.",
    "quoteNotFound": "Unable to load quote",
    "quotesNotFound": "Unable to load quotes",
    "refresh": "Other users have made changes. Please refresh the page.",
    "registration": "Something went wrong while trying to send the registration",
    "registrationTokenError": "The link to register a new user appears to be invalid. Please request a new one.",
    "requiredField": "Required field",
    "resetPassword": "Something went wrong while trying to reset the password",
    "resetTokenError": "This password reset link is no longer valid. Please request a new one.",
    "serverError": "Server error",
    "shortPassword": "Has to be at least 8 characters long",
    "startPage": "Start page could not be loaded",
    "timeout": "The request timed out",
    "tooManyRequests": "Too many requests. Try again later.",
    "unknownError": "An unknown error occurred during the request ({0}).",
    "unknownLoginError": "An unknown error occurred when logging in.",
    "unsupportedMediaType": "The file type is not supported",
    "updateComment": "The free text comment could not be updated",
    "userDeactivated": "The specified user is deactivated, login is currently not possible.",
    "validDigit": "The value has to be a valid integer",
    "wrongCredentials": "Your email address or password is incorrect."
  },
  "errorId": "Error ID",
  "errorPageHeadline": "Something went wrong.",
  "errorPageOops": "Oops",
  "errorPageQuoteNotAvailableSorry": "Please try again later.",
  "errorPageStart": "Go to start page",
  "essentialShopDeactivated": {
    "descriptionEnd": "Talk to your partner to gain access.",
    "descriptionPoint1": "View the history of your offers",
    "descriptionPoint2": "Submit requests for offers directly to your partner",
    "descriptionPoint3": "Access a range of 50,000 IT products with filters and search functions",
    "descriptionPoint4": "Order easily and directly",
    "descriptionStart": "In the Essential Shop, you have the option to:",
    "descriptionTitle": "Your partner's Essential Shop is currently deactivated.",
    "pageTitle": "Essential Shop deactivated",
    "requestActivation": "Request activation",
    "requestActivationHint": "Please provide your email address so that your partner can contact you."
  },
  "excludingVatHint": "All prices excl.{0} VAT",
  "excludingVatShort": "excl.{0} VAT",
  "expandAccessoryCategory": "Expand accessories category ‘{0}’",
  "expandDescription": "Expand description ‘{0}’",
  "featureAd": {
    "comparison": {
      "description": "Products can be added via the product page",
      "shortDescription": "You can now compare products.",
      "title": "Product comparison"
    },
    "descriptionEnd": "We will be notified and present you with a directly orderable quote right here in your portal.",
    "descriptionStart": "This is how you request a collection of products:",
    "NEW": "NEW",
    "requestFunction": "Sending requests for quotes",
    "step1": "Click \"Create request\"",
    "step2": "Add products",
    "step3": "Send the request",
    "tryItOut": "Try it out!"
  },
  "filter": {
    "filter": "Filter",
    "filters": "Filters",
    "noFiltersSelected": "No filters selected",
    "productFilters": "Features",
    "productType": "Product type",
    "resetFilter": "Reset filter"
  },
  "finishRegistration": "Finish registration",
  "forgotPassword": "Forgot password?",
  "grading": {
    "A": "Like new",
    "B": "Very good",
    "C": "Good",
    "D": "Acceptable"
  },
  "hideCategories": "Hide categories",
  "hideCategory": "Fold the category",
  "hidePassword": "Hide the password",
  "impersonateMode": "Customer's view - You are logged in as B2B shop admin in {0}",
  "impersonateModeEssentialShop": "Customer view – Logged in as shop owner",
  "includingVat": "incl.{0} VAT",
  "includingVatHint": "All prices incl.{0} VAT",
  "includingVatShort": "incl.{0} VAT",
  "invitationHint": "Invite colleagues to your portal by entering their email addresses, separated by semicolons or spaces.",
  "inviteColleagues": "Invite colleagues",
  "languages": {
    "de": "German",
    "en": "English",
    "es": "Spanish",
    "fr": "French",
    "it": "Italian",
    "nl": "Dutch",
    "pl": "Polish"
  },
  "legalInfo": "Legal Info",
  "less": "less",
  "localization": "Localization",
  "login": "Login",
  "login_sso": "Log in with Single Sign-On (SSO)",
  "loginQuotesPortal": "Login quotes portal",
  "manufacturerId": "Manufacturer ID",
  "max": "Max.",
  "maxLength": "Maximum character length of {0} reached",
  "mobex360Info": "If the mobex360 credit is insufficient, the order will automatically be invoiced!",
  "mobexPaymentMethod": {
    "CREDIT": "With mobex360 credit",
    "INVOICE": "By invoice"
  },
  "more": "more",
  "moreInfoEpeatTooltip": "Further information on the EPEAT label",
  "moreUppercase": "More",
  "myCompany": "My company",
  "myProfile": "My profile",
  "name": "Name",
  "newPassword": "New password",
  "newPasswordRepeat": "Confirm new password",
  "no": "No",
  "noAppleProductsAvailable": "No Apple products available",
  "noCategoriesFound": "No categories available",
  "noCollectionsFound": "No collections available",
  "noDataAvailable": "No data available",
  "noEntries": "No entries available",
  "noImageAvailable": "No picture available",
  "noItemsInQuote": "This quote does not contain any items",
  "noOrderDocumentsFound": "No documents available",
  "noOrdersFound": "No orders available",
  "noProductsFound": "No products found",
  "noSupplier": "Unassigned",
  "nullPriceLabel": "-.--",
  "oldPassword": "Current password",
  "onlyWholePositiveNumbers": "Only positive whole numbers allowed",
  "open": "Open",
  "openCart": "Open the shopping cart",
  "openCategory": "Fold out the category",
  "openFilter": "Open the filter",
  "openMenu": "Open menu",
  "openProductComparison": "Open the product comparison",
  "openProductPage": "Open product page",
  "openTopiCheckout": "Open topi-Checkout",
  "optimizationStrategyType": {
    "MANUAL": "Manually",
    "MINPRICE": "Best price",
    "MINSUPPLIERS": "Minimum sources"
  },
  "order": {
    "addedToCartFailure": "Order could not be added to the cart",
    "addedToCartPartialSuccess": "Some items could not be added to the cart",
    "addedToCartSuccess": "Added order to cart",
    "customerOrderIdMissing": "A customer order ID is required.",
    "declineOrder": "Decline order",
    "deleteDialog": "Are you sure you want to delete this order?",
    "deleteLastItemDialog": "Attention: When deleting the last order item, the complete order will also be deleted. Do you want to continue?",
    "deleteOrder": "Delete order",
    "deleteOrderItem": "Delete order position",
    "details": "Order",
    "documents": "Documents",
    "editAddressHint": "Changes to the address only affect this order.",
    "exclTotalTax": "excl.{0} VAT {1}",
    "goToOrder": "Continue to order",
    "inclTotalTax": "incl.{0} VAT {1}",
    "inEuTotalTax": "plus{0} VAT {1}",
    "moreInfosLabel": "Further details",
    "netDiscount": "Additional discount",
    "noApprover": "There seems to be no approver eligible for this order. Please contact your portal's operator.",
    "noOrderRightHint": "You have no permission to execute the order.",
    "order": "Order",
    "orderAlreadyBeingProcessed": "Order is already being processed. Please wait a few minutes for it to be completed.",
    "orderDate": "Order date",
    "orderLimitApprovalHint": "The following people will be notified by email about your order approval request. As soon as the order approval has been confirmed or rejected, you will be informed by email.",
    "orderLimitHint": "The order worth {0} has exceeded your current order limit of {1}. Please request an order approval.",
    "orderNotFound": "Order could not be loaded",
    "orderNumber": "Order number",
    "orderNumberDuplicate": "The order number {0} has already been used for an order. Please try another order number.",
    "orderNumberGeneratedAfterOrder": "Is generated after the order",
    "orderNumberMissing": "An order number must be given.",
    "orderNumbers": "Order numbers",
    "orderRequested": "Request sent",
    "orders": "Orders",
    "orderSent": "Your order has been submitted and is now being processed.",
    "orderTimeoutError": "No order response received. Please reload the page.",
    "partialShipmentAllowed": "Partial shipment allowed",
    "paymentMethodMissing": "A billing method must be given.",
    "quantitySurcharge": "Minimum order surcharge",
    "requestOrder": "Request",
    "selectAddressHint": "Only addresses created by you can be used.",
    "sendOrder": "Confirm purchase",
    "shippingAddress": "Shipping address",
    "shippingCosts": "Shipping",
    "shippingCostsGross": "Gross shipping costs",
    "shippingCostsNet": "Shipping costs net",
    "subTotal": "Subtotal",
    "toOrder": "Order",
    "toOrderFrom": "Order from {0}",
    "totalCostsGross": "Total amount gross",
    "totalCostsNet": "Total amount net"
  },
  "orderApproval": {
    "approvableOrders": "Approvable orders",
    "approvedInformation": "Order was approved by {0} on {1}.",
    "declinedInformation": "Order was declined by {0} on {1}.",
    "orderDeclined": "Order successfully declined",
    "pendingInformation": "On {0}, {1} sent an order approval request to the following persons:",
    "pendingInformationApprover": "On {0}, an order approval was submitted to your account.",
    "pendingInformationRequester": "On {0}, you submitted an order approval to the following person:"
  },
  "orderBy": "Order placed with {0}",
  "ordered": "Ordered",
  "orderLimits": {
    "activateOrderLimits": "Activate order limits",
    "default": "Default",
    "defaultApprovers": "Default approver",
    "defaultApproversEmpty": "No default approver selected",
    "defaultApproversUsed": "Default approvers are used",
    "defaultLimit": "General limit",
    "defaultLimitDescription": "This order limit is the default value for all employees and is overwritten by specific order limits for employees.",
    "description": "By assigning limits, employees can only order up to a specified value. Orders that exceed this value must be requested from a colleague with approval rights.",
    "editOrderLimitUser": "Change order limit of user ‘{0}’",
    "editStandardApprovers": "Edit default approvers",
    "individual": "Individual",
    "noEmployeeFound": "No employee found",
    "noEmployeesFound": "No employees found",
    "orderApproval": "Order approval",
    "orderApprover": "Order approver",
    "orderLimit": "Order limit",
    "orderRight": "Order right",
    "unlimited": "Unlimited"
  },
  "orderOutdated": {
    "description": "The order could not be sent because it is no longer up to date. Please reload the order and execute it again.",
    "title": "Order no longer up to date"
  },
  "orderStatus": {
    "ADVISED": "Dispatched",
    "ARRIVED": "Order received",
    "ARRIVED_WARNING": "Received with warning",
    "BLOCKED": "Blocked",
    "BLOCKED_BYLIMIT": "Blocked",
    "CANCELED": "Canceled",
    "ERROR": "Error",
    "IN_TOPI_CHECKOUT": "In the topi checkout",
    "INVOICED": "Invoiced",
    "ORDERED_ELSEWHERE": "Ordered elsewhere",
    "PARTIALLY_ADVISED": "Partially shipped",
    "PARTIALLY_INVOICED": "Partially invoiced",
    "PARTIALLY_PROCESSING": "Partially confirmed",
    "PAYMENT_AWAITING": "Awaiting payment",
    "PAYMENT_SUCCESSFUL": "Payment successful",
    "PENDING_TOPI_APPROVAL": "Pending approval",
    "PORTAL_APPROVAL_DENIED": "Rejected",
    "PREPARING": "Pending",
    "PROCESSING": "Order confirmed",
    "REJECTED": "Rejected",
    "SENDING_ERROR": "Transmission error",
    "SENT": "Transmitted",
    "TOPI_DECLINED": "Declined by topi",
    "TOPI_EXPIRED": "topi offer expired",
    "TRANSMITTING": "Transmitting"
  },
  "partsList": "Parts list",
  "password": "Password",
  "passwordRepeat": "Repeat password",
  "paymentMethod": "Payment method",
  "PDF": "PDF",
  "per": "per",
  "personalData": "Personal Data",
  "pleaseSelect": "Please select...",
  "portal": "Portal",
  "portalPaused": "Portal paused",
  "portalPausedDescription": "This portal is currently paused, therefore login is not possible. If you have any questions, please contact your portal owner.",
  "positions": "No position | {n} position | {n} positions",
  "price": {
    "graduatedPrices": "Graduated prices",
    "manufacturerSuggestedRetailPrice": "MSRP",
    "packaging": "Packing unit",
    "packaging_contentUnit": "Content unit:",
    "packaging_contentUnit_label": "Unit of the article within an order unit (e.g. \"piece\" in order unit \"pack\").",
    "packaging_intervalQuantity": "Quantity interval:",
    "packaging_intervalQuantity_label": "Quantity that indicates the interval in which the article can be ordered (in order units).",
    "packaging_minQuantity": "Minimum order quantity:",
    "packaging_minQuantity_label": "The lowest amount of stock that must be ordered.",
    "packaging_numberContentUnitPerOrderUnit": " Packaging quantity:",
    "packaging_numberContentUnitPerOrderUnit_label": "The number of subunits contained in the unit of the article.",
    "packaging_orderUnit": "Order unit:",
    "packaging_orderUnit_label": "Unit, in which the product can be ordered; only multiples of the article unit can be ordered.",
    "packaging_priceQuantity": "Price quantity:",
    "packaging_priceQuantity_label": "A multiple of the order unit, which indicates the quantity to which the prices refer.",
    "packaging_supplierPackingQuantity": "Supplier packaging quantity:",
    "packaging_supplierPackingQuantity_label": " Packaging quantity of the supplier (in order units).",
    "price": "Price",
    "priceBillingPeriod": "per {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "O/R",
    "pricePurchase": "WSP",
    "priceSubscriptionPeriod": "{0} contract period",
    "priceVatStar": "*",
    "startingAt": "starting at {0}"
  },
  "priceRange": {
    "applyPriceRange": "Apply price range",
    "fromPriceRange": "From {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Invalid price range",
    "priceRange": "Price range",
    "priceRangeFrom": "Price range from",
    "priceRangeTo": "Price range to",
    "toPriceRange": "Up to {0} {1}"
  },
  "print": "Print",
  "privacy": "Privacy",
  "privacyConsent": "I agree that my data will be processed in accordance with the privacy policy.",
  "product": "Product",
  "productAccessories": "Accessories",
  "productComparison": {
    "highlightDifferences": "Highlight differences",
    "noData": "No comparable data was found for the selected products",
    "noMobileVersion": "The product comparison is not available in the mobile view",
    "noProducts": "No products in comparison",
    "pageTitle": "Compare products",
    "removeProduct": "Remove product from comparison"
  },
  "productDescription": "Description",
  "productId": "Product ID",
  "productIdentifiers": "Product IDs",
  "productNoLongerAvailable": "Product no longer available",
  "products": "Products",
  "productSort": {
    "AVAILABILITY": "Availability",
    "CALC_PRICE_ASC": "Price ascending",
    "CALC_PRICE_DESC": "Price descending",
    "NAME_ASC": "Product name ascending",
    "NAME_DESC": "Product name descending",
    "POPULARITY": "Popularity",
    "RELEVANCE": "Relevance",
    "STOCK": "Stock level"
  },
  "productStockInfo": {
    "nextDelivery": "Next delivery date according to distributor expected on {0}.",
    "nextDeliveryB2B": "Expected delivery date to the upstream supplier: {0}.",
    "noNextDelivery": "The precise delivery date is unknown.",
    "onStock": "{0} in stock",
    "onSupply": "{0} soon available",
    "unavailableMessage": "This product is not available."
  },
  "punchout": {
    "backToProcurement": "Back to your system",
    "backToProcurementCaption": "Without order back to your system | Take a position in your system | {n} positions back to your system",
    "table": {
      "position": "ID",
      "price": "Price",
      "quantity": "Qty",
      "sum": "Sum",
      "title": "Title"
    }
  },
  "quantityFrom": "Quantity from",
  "quoteOutdated": {
    "description": "The order could not be sent because the quote is no longer up to date. Please reload the quote and place the order again.",
    "title": "Quote no longer up to date"
  },
  "quotePreview": "You are in the quote preview",
  "quoteRegistration": {
    "description": "By registering in your personal Essential Shop, you will receive...",
    "products": "Access to <b>50,000 IT products</b>",
    "quoteDocument": "access to all relevant <b>quote documents</b>",
    "quoteHistory": "the <b>quote history</b> with all previously received quotes",
    "quoteRequest": "the option to submit <b>requests</b>"
  },
  "quoteRequest": {
    "cannotEditRequest": "No more change possible, the request has already been sent.",
    "emptyRequest": "No products added yet",
    "lineItemAdded": "Item was added successfully",
    "notInAssortment": "Currently not in the assortment",
    "requestAgain": "Request again",
    "requestNotFound": "Quote request could not be found",
    "sendRequest": "Send request",
    "sentQuoteRequest": "Quote request was sent",
    "textLineItemAdd": "Add text item",
    "textLineItemChangeError": "Text position title could not be changed"
  },
  "quotes": {
    "acceptQuote": "Accept quote",
    "addProductToExistingQuote": "Add product to existing request:",
    "addProductToNewQuote": "or create new request:",
    "author": "Author",
    "createRequest": "Create request",
    "declineInformation": "Quote was declined by {0} on {1}.",
    "declineQuote": "Decline quote",
    "declineQuoteDialog": "Are you sure you want to decline this quote?",
    "deleteDescription": "Are you sure you want this request to be deleted?",
    "deleteTitle": "Delete request",
    "deselectOptionalItem": "Deselect optional position",
    "duplicateUserWarning": "You cannot accept this offer because your e-mail address has already been linked to another company. Please contact the creator of the offer.",
    "editTitle": "Change title of the quote request",
    "new": "New",
    "noLongerValid": "This quote expired on \"{0}\" and is no longer valid.",
    "noOptionalPosition": "No optional position",
    "noQuoteEmptySpace": "No quote available yet",
    "noQuoteRequestsFound": "No requests available",
    "noQuotesFound": "No quotes available",
    "quote": "Quote",
    "quoteRequested": "Request created successfully",
    "quotes": "Quotes",
    "request": "Request",
    "selectOptionalItem": "Select optional position",
    "showActivity": "Show activities"
  },
  "quoteStatus": {
    "ACCEPTED": "Accepted",
    "DRAFT": "Draft",
    "NEGOTIATION": "In progress",
    "REJECTED": "Rejected",
    "REQUESTED": "Requested"
  },
  "readOnlyMode": "You are currently in read-only mode.",
  "realtimePrices": "Realtime prices",
  "realtimePricesLoaded": "Real-time prices loaded",
  "recipients": "Recipients",
  "refresh": "Refresh",
  "refreshPage": "Reload page",
  "register": "Register",
  "registerCompany": "Register company",
  "registration": "Registration",
  "registrationDisabled": "Registration disabled",
  "registrationDisabledDescription": "The owner has deactivated registration and logging in to this portal.",
  "registrationLinkSent": "An e-mail with the registration link has been sent to your e-mail address. Please open the link to complete the registration.",
  "registrationRequested": "The request has been transmitted to the portal operator. You will receive a notification once the request has been accepted.",
  "removeDialog": "Are you sure you want to remove this employee?",
  "removeProductFromCart": "Remove product from cart",
  "removeProductFromCollection": "Remove product from collection",
  "removeProductFromQuoteRequest": "Remove the product from request",
  "requestPrice": "Request price",
  "requestRegistration": "Request access",
  "resetPassword": "Reset password",
  "rma": {
    "requested": "Return request sent",
    "return": "Return",
    "returned": "returned",
    "returnReason": "Return reason",
    "selectedPositions": "Selected positions",
    "selectPositions": "Please select the items for your return shipment",
    "selectProductForReturn": "Select product for return",
    "selectReturnReason": "Select reason"
  },
  "save": "Save",
  "saveAddress": "Save address",
  "search": "Search",
  "searchAll": "Search all",
  "searchResults": "Search for \"{0}\" in products",
  "send": "Send",
  "sendInvitation": "Send invitation",
  "serialNumbers": {
    "copyAll": "Copy all",
    "serialNumbers": "Serial numbers",
    "serialNumbersCopied": "Serial numbers copied to the clipboard"
  },
  "serverOffline": {
    "description": "The portal is currently unavailable due to maintenance. Please try again later.",
    "title": "Portal not available"
  },
  "shippingCostsShort": "Shipping",
  "shoppingCart": "Shopping cart",
  "shortUrl": {
    "enterZipCode": "To open the quote, please enter the postcode of your address:",
    "enterZipCodeTitle": "Enter postcode",
    "error": "Oops! This link is not valid!",
    "wrongZipCode": "The postcode you entered is invalid!"
  },
  "showCategories": "Show categories",
  "showErrorOrders": "Show all orders with an error status",
  "showPassword": "Show password",
  "signIn": "Login",
  "signOut": "Sign out",
  "sortBy": "Sort by",
  "sortbyAsc": "Sort in ascending order by ‘{0}’",
  "sortByDesc": "Sort in descending order by ‘{0}’",
  "sources": "Sources of supply",
  "status": "Status",
  "stock": "Stock",
  "stockStatus": {
    "Available": "Available",
    "NotAvailable": "Not available",
    "OnOrder": "Order-based",
    "OnStock": "In stock",
    "Ordered": "Soon available",
    "Unknown": "Unknown",
    "Warehouse": "external stock"
  },
  "stockStatusDescription": "Stock status is ‘{0}’",
  "subsidiaryMode": "Customer's view - You are logged in at {0}",
  "success": {
    "addedToCollection": "Product successfully added to collection",
    "addedToCollectionLink": "Product successfully added to collection \"{0}\" >>",
    "addedToComparison": "Product added to comparison",
    "addedToQuote": "Product was successfully added to the request.",
    "addedToQuoteLink": "Product was successfully added to request \"{0}\". >>",
    "addressCreated": "Address was created",
    "addressDeleted": "Address was deleted",
    "addressSaved": "Address was saved",
    "cartRefreshed": "Shopping cart updated",
    "changeLanguage": "Language changed",
    "changePassword": "Password changed successfully",
    "essentialShopActivationRequested": "Activation request sent",
    "invitationSent": "Invitation sent successfully",
    "orderArchived": "Order archived",
    "orderDearchived": "Order dearchived",
    "productAdded": "Product was added to the cart",
    "productDeleted": "Product was deleted from the cart",
    "productRequested": "Request for product sent",
    "quoteArchived": "Quote archived",
    "quoteDearchived": "Quote dearchived",
    "registrationComplete": "Registration successful",
    "removedFromComparison": "Product has been removed from the comparison",
    "resetPassword": "An email has been sent to \"{0}\" if an active user account exists."
  },
  "supplier": "Supplier",
  "supplierPid": " Distributor no.",
  "switchSubsidiary": "Change company",
  "switchSubsidiaryHint": "You can log into other companies",
  "technicalData": "Technical Data",
  "terms": "GTC",
  "time": {
    "day": "day",
    "hour": "hour",
    "minute": "minute",
    "month": "month",
    "year": "year"
  },
  "title": "Title",
  "to": "to",
  "today": "Today",
  "topiExpiredHint": "The offer at topi has unfortunately expired. Please add the products to your shopping basket again using the three-dot menu and then click on ‘Continue to rental configuration’.",
  "transactionType": {
    "DELIVERY": "Delivery note",
    "INVOICE": "Proforma invoice",
    "ORDER": "Order",
    "ORDERSTATUS": "Order response",
    "PAYMENT": "Payment"
  },
  "unknown": "unknown",
  "updated": "Updated",
  "user": {
    "avatar": "Avatar",
    "company": "Company",
    "contactTitle": "Contact title",
    "department": "Department",
    "email": "E-Mail",
    "firstName": "First Name",
    "language": "Language",
    "lastName": "Last Name",
    "permissions": {
      "changeSubsidiary": "Switch companies",
      "changeSubsidiaryDescription": "Determines whether the user is allowed to log in to related companies.",
      "permissions": "User permissions",
      "shopAdmin": "Admin",
      "shopAdminDescription": "As an admin, the user is authorized to edit the rights, contact details, order limits and approvals of other employees. In addition, the admin user can invite new colleagues directly to the portal.",
      "submitOrder": "Place orders",
      "submitOrderDescription": "Determine if the user is allowed to place orders."
    },
    "phone": "Mobile phone number",
    "phoneMobile": "Phone number",
    "settings": {
      "allowTracking": "Improve user experience",
      "allowTrackingDescription": "Take part in the optimisation programme for a better user experience.",
      "settings": "User settings"
    }
  },
  "validDate": "Valid until",
  "viewToggle": {
    "ordersApprovals": "Switch the order overview to \"Approvable orders\"",
    "ordersGrid": "Switch the order overview to the column view",
    "ordersList": "Switch the order overview to list view",
    "productsCards": "Switch the product overview to tiled view",
    "productsList": "Switch the product overview to list view",
    "quoteActivityChat": "Switch activity view to chat",
    "quoteActivityHistory": "Switching activities view to history"
  },
  "windowTitle": {
    "Collection": "Collection",
    "CompanyOrderLimit": "Order approval",
    "Login": "Login page",
    "Registration": "Registration page",
    "StartPage": "Start page"
  },
  "writeSomething": "Write something...",
  "yes": "Yes",
  "yesterday": "Yesterday"
}